<template>
    <div>
        <b-form @submit.stop.prevent="onSubmit">
            <b-form-group label="Destinatários" 
            description=""
            label-for="multi"
            >
                <div>
                    <v-select v-model="to" multiple :options="userDDL" placeholder="Selecionar destinatários" label="text"></v-select>                    
                </div>
            </b-form-group>

            <b-form-group label="Mensagem" 
            description=""
            label-for="usermessage"
            >
                <div slot="header">
                Mensagem
                <div class="card-header-actions">
                    <a href="https://github.com/surmon-china/vue-quill-editor" rel="noreferrer noopener" target="_blank" class="card-header-action">
                    <small class="text-muted">?</small>
                    </a>
                </div>
                </div>
                <quill-editor v-model="userMessage" :content="userMessage" :options="editorMessageOptions"></quill-editor>
            </b-form-group>

            <div class="text-right">
                <b-button @click="sendMessage()" variant="primary" :disabled="sendingMessage"><i class="fa fa-send"></i> Enviar Mensagem</b-button>   
            </div>

        </b-form>
    </div>
</template>

<script>
import axios from "axios";
import Vue from 'vue'

import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)

import VueQuillEditor from 'vue-quill-editor'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)

/*
Máscara
*/
import MaskedInput from 'vue-text-mask'
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe'
import Multiselect from 'vue-multiselect'
import vSelect from 'vue-select'
import { setupCalendar, DatePicker } from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'

const base64Encode = data =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

export default {
  name: "ComponentUserMessage",
  components: {
    MaskedInput,
    Multiselect,
    vSelect,
    'v-date-picker': DatePicker,      
  },
  props: {
    userId: Number
  },
  data() {
    return {
        sendingMessage: false,
        to: [],
        userDDL: [],
        editorMessageOptions: {
            placeholder: 'Entre com sua mensagem',
            readonly: false
        },

        userMessage: '',

    }
  },
  computed: {
    propUserId() {
      if(!this.userId) return 0
      return this.userId
    },

  },
  methods: {
    async postMessage() {
        this.sendingMessage = true;
        var s = this;
        var currentUser = this.$store.state.currentUser;
        var data = {
            bodyText: this.userMessage,
            to: this.to.map(item => parseInt(item.value)),
            userId: currentUser.id,
            uid: currentUser.id,
            sid: currentUser.sid
        }

        await axios.post(
            this.$store.state.ws_url + "/message",
            data
        ).then(function(resp) {
            s.sendingMessage = false
            s.to = []
            s.userMessage = ''
            //console.log(resp.data)
            toast ({
                type: VueNotifications.types.success,
                title: 'Enviar Mensagem',
                message: 'Mensagem enviada com sucesso',
                timeout: 2000
            });
            s.$emit('resp',{ code: 1, message: 'Mensagem enviada com sucesso' })           
        })
        .catch(function(error) {
            s.sendingMessage = false
            toast ({
                type: VueNotifications.types.error,
                title: 'Enviar Mensagem',
                message: 'Erro ao enviar mensagem: ' + resp.data.obj,
                timeout: 2000
            });
            
            s.$emit('resp',error.data)
        });
    },

    sendMessage() {
        if(!this.userMessage || this.userMessage.length <= 0 || this.to.length <= 0) {
            toast ({
                type: VueNotifications.types.error,
                title: 'Enviar Mensagem',
                message: 'Verifique os destinatários e a mensagem enviada.',
                timeout: 3000
            })
        }
        else {
            this.postMessage()
        }
    },

    async refreshUserList() {
      var s = this;
      var currentUser = this.$store.state.currentUser;
      await axios.get(
          this.$store.state.ws_url + "/user/ddl?companyId=" + currentUser.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
      ).then(function(resp) {
          if(resp.data.obj && resp.data.obj.length > 0) {
            s.userDDL = resp.data.obj;
            
          }
          else {
            s.accounts = {
                balance: 0
            }
          }
          
      })
      .catch(function(error) {
          console.log(error);
      });
      
    },
  },
  mounted: function() {
    this.refreshUserList()
  }
  
};


</script>

<style lang="scss" scoped>

.ql-editor{
    min-height:200px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

